const BaseURLStaging = process.env.VUE_APP_URL_API_STAGING;
const BaseURLProduct = process.env.VUE_APP_URL_API_PRODUCT;
const BaseURLDev = process.env.VUE_APP_URL_API_DEV;
const BaseURLLocal = process.env.VUE_APP_URL_API_DEV;

const node = process.env.VUE_APP_NOTE;

const BaseURL =
  node == "PRODUCT"
    ? BaseURLProduct
    : node == "STAGING"
    ? BaseURLStaging
    : node == "DEV"
    ? BaseURLDev
    : BaseURLLocal;
// userPoolId
const userPoolIdTeacherDEV = process.env.VUE_APP_COGNITO_USER_POOL_ID_DEV;
const userPoolIdTeacherStaging =
  process.env.VUE_APP_COGNITO_USER_POOL_ID_STAGING;
const userPoolIdTeacherProduct =
  process.env.VUE_APP_COGNITO_USER_POOL_ID_PRODUCT;

const userPoolIdAdminDEV = process.env.VUE_APP_COGNITO_USERPOOL_ID_DEV;
const userPoolIdAdminStaging = process.env.VUE_APP_COGNITO_USERPOOL_ID_STAGING;
const userPoolIdAdminProduct = process.env.VUE_APP_COGNITO_USERPOOL_ID_PRODUCT;

const userPoolIdTeacher =
  node == "PRODUCT"
    ? userPoolIdTeacherProduct
    : node == "STAGING"
    ? userPoolIdTeacherStaging
    : userPoolIdTeacherDEV;

const userPoolIdAdmin =
  node == "PRODUCT"
    ? userPoolIdAdminProduct
    : node == "STAGING"
    ? userPoolIdAdminStaging
    : userPoolIdAdminDEV;

// Client id
const clientIdTeacherDEV = process.env.VUE_APP_COGNITO_USER_CLIENT_ID_DEV;
const clientIdTeacherStaging =
  process.env.VUE_APP_COGNITO_USER_CLIENT_ID_STAGING;
const clientIdTeacherProduct =
  process.env.VUE_APP_COGNITO_USER_CLIENT_ID_PRODUCT;

const clientIdAdminDEV = process.env.VUE_APP_COGNITO_CLIENT_ID_DEV;
const clientIdAdminStaging = process.env.VUE_APP_COGNITO_CLIENT_ID_STAGING;
const clientIdAdminProduct = process.env.VUE_APP_COGNITO_CLIENT_ID_PRODUCT;

const clientIdTeacher =
  node == "PRODUCT"
    ? clientIdTeacherProduct
    : node == "STAGING"
    ? clientIdTeacherStaging
    : clientIdTeacherDEV;

const clientIdAdmin =
  node == "PRODUCT"
    ? clientIdAdminProduct
    : node == "STAGING"
    ? clientIdAdminStaging
    : clientIdAdminDEV;

// redirect SSO
const appDomain =
  node == "PRODUCT"
    ? process.env.VUE_APP_COGNITO_APP_DOMAIN_PRODUCT
    : node == "STAGING"
    ? process.env.VUE_APP_COGNITO_APP_DOMAIN_STAGING
    : process.env.VUE_APP_COGNITO_APP_DOMAIN_DEV;
const redirect =
  node == "PRODUCT"
    ? process.env.VUE_APP_COGNITO_REDIRECT_URI_PRODUCT
    : node == "STAGING"
    ? process.env.VUE_APP_COGNITO_REDIRECT_URI_STAGING
    : process.env.VUE_APP_COGNITO_REDIRECT_URI_DEV;
const redirectSigout =
  node == "PRODUCT"
    ? process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT_PRODUCT
    : node == "STAGING"
    ? process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT_STAGING
    : process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT_DEV;

const REGION = process.env.VUE_APP_AWS_REGION;

const IDENTITY_POOL_ID = process.env.VUE_APP_COGNITO_IDPOOL_ID;

export {
  BaseURL,
  userPoolIdTeacher,
  userPoolIdAdmin,
  clientIdAdmin,
  clientIdTeacher,
  appDomain,
  redirect,
  redirectSigout,
  REGION,
  IDENTITY_POOL_ID,
};
